import React from 'react';
import styled from 'styled-components';
// import { ReadMore } from './ReadMore';
// import { ReadMoreWayfair } from './read_mores/ReadMoreWayfair';
import Carousel43 from './Carousel43';
import Carousel from './Carousel';

function CuttingBoards({navbarSelected}) {
    // const cgfLink = "https://sell.wayfair.com/operate-castlegate-forwarding";
    // const lillipiesLink = "https://lillipies.com/";
    // const readMoreWayfair = (
    //     <ReadMoreWayfair />
    // );
    // const readMoreWayfairShowText = "Click to read more about a specific problem I tackled!";

    const end_grains = [
        `<img src='end_grain_cutting_boards/IMG_0836.jpeg' alt='End Grain Cutting Board' />`,
        `<img src='end_grain_cutting_boards/IMG_0829.jpeg' alt='End Grain Cutting Board' />`,
        `<img src='end_grain_cutting_boards/IMG_0831.jpeg' alt='End Grain Cutting Board' />`,
        `<img src='end_grain_cutting_boards/IMG_0835.jpeg' alt='End Grain Cutting Board' />`,
    ];

    const side_grains = [
        `<img src='side_grain_cutting_boards/IMG_0828.jpeg' alt='Cutting Board' />`,
        `<img src='side_grain_cutting_boards/IMG_0834.jpeg' alt='Cutting Board' />`,
        `<img src='side_grain_cutting_boards/IMG_0837.jpeg' alt='Cutting Board' />`,
        `<img src='side_grain_cutting_boards/IMG_0866.jpeg' alt='Cutting Board' />`,
        `<img src='side_grain_cutting_boards/IMG_0839.jpeg' alt='Cutting Board' />`,
        `<img src='side_grain_cutting_boards/IMG_0833.jpeg' alt='Cutting Board' />`,
    ];

    if (navbarSelected === "cutting_boards") return (
        <WorkInfo>
            <div className='items'>
                <h2>
                    End Grain Cutting Boards
                </h2>
                <Carousel items={end_grains} />


                <h2>
                    Side Grain Cutting Boards
                </h2>
                <Carousel43 items={side_grains} />


            </div>
        </WorkInfo>
    )
}


const WorkInfo = styled.div`
.items {
    display: block;
}
`



// = styled.div`
//     .items {
//         display: flex;
//         flex-direction: column;
//         align-items: center;
//     }

//     img {
//         width: 278px;
//         height: 300px;
//         align-items: center;
//         margin: 35px;
//         border-radius: 15px;
//     }
// `


export default CuttingBoards;
